import { Component, signal, computed, ChangeDetectionStrategy, forwardRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule } from '@angular/forms';
import { COUNTRIES } from './model/corp-input-tel.model';
import { PhoneService } from './service/corp-input-tel.service';
import { CorpControlCommonComponent } from '../../common/corp-control-common/corp-control-common.component';
import { CorpDropdownComponent } from '@corporate-tailwind/component';
import { SelectPhone } from '@corporate-tailwind/model';
import { CorpControlTitleComponent } from '../../common/corp-control-title/corp-control-title.component';

@Component({
    selector: 'corp-input-phone',
    standalone: true,
    templateUrl: 'corp-input-tel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, FormsModule, CorpDropdownComponent, CorpControlTitleComponent],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CorpInputPhoneComponent),
            multi: true,
        },
    ],
})
export class CorpInputPhoneComponent extends CorpControlCommonComponent implements OnInit {
countries = COUNTRIES;

selectedCountryCode = signal('FR');
phone = '';
mask= '## ## ## ## ##';
selectedCountry = computed(() =>
this.countries.find(c => c.code === this.selectedCountryCode())!
);
form : FormGroup | null = null;


    constructor(
        private _injector: Injector,
        private _phoneService: PhoneService,
        private _formBuilder: FormBuilder
    ) {
        super();
        this.initForm(this.countries[0]);
    }

    ngOnInit(): void {
        // const ngControl = this.injector.get(NgControl, null)
        // this.setNgControl(ngControl)
        this.form?.get('selectPhone')?.valueChanges.subscribe(phone => {
  this.mask = phone?.mask ?? '';
});
    }

    initForm(selectPhone: SelectPhone) {
        this.form = this._formBuilder.group({
            selectPhone: new FormControl(selectPhone ?? null),
            phone: new FormControl(null)
        });
    }

    override onInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  // garde uniquement les chiffres
  const raw = input.value.replace(/\D/g, '');

  // applique le format
  const masked = this.applyMask(raw);

  // update affichage
  input.value = masked;

  // update valeur Angular
  this.value = raw;
  this.onChange(raw);
}

  private applyMask(value: string): string {
  if (!this.mask) return value;

  let result = '';
  let vi = 0;

  for (let mi = 0; mi < this.mask.length; mi++) {
    const m = this.mask[mi];

    if (m === '0' || m === '#') {
      if (vi < value.length) {
        result += value[vi++];
      } else {
        break;
      }
    } else {
      result += m;
    }
  }

  return result;
}


}





// @Component({
//   selector: 'corp-input-phone',
//   standalone: true,
//   imports: [FormsModule, PhoneMaskDirective],
//    templateUrl: 'corp-input-tel.component.html'
// })
// export class CorpInputPhoneComponent {

//   countries = COUNTRIES;

//   selectedCountryCode = signal('FR');
//   phone = '';

//   selectedCountry = computed(() =>
//     this.countries.find(c => c.code === this.selectedCountryCode())!
//   );

//   constructor(private phoneService: PhoneService) {}

//   isValid(): boolean {
//     return this.phoneService.isValid(
//       '+' + this.selectedCountry().dialCode + this.phone,
//       this.selectedCountry().code
//     );
//   }

//   onBlur() {
//     this.phone = this.phoneService.format(
//         '+' + this.selectedCountry().dialCode + this.phone,
//         this.selectedCountry().code
//     );
//     }
// }